import { useEffect, useState } from "react";

export default function Preloader() {
  const [hidden, setHidden] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    const fade = setTimeout(() => setHidden(true), 1800);
    const finish = setTimeout(() => {
      setDone(true);
      document.body.style.overflow = "";
    }, 2600);
    return () => {
      clearTimeout(fade);
      clearTimeout(finish);
      document.body.style.overflow = "";
    };
  }, []);

  if (done) return null;

  return (
    <div
      data-testid="preloader"
      className={`fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-[#2a162f] transition-opacity duration-[800ms] ease-out ${
        hidden ? "opacity-0" : "opacity-100"
      }`}
    >
      {/* Ambient gold glow */}
      <div className="pointer-events-none absolute w-[520px] h-[520px] rounded-full bg-[#c5a059] opacity-[0.13] blur-[130px]" />
      <div className="pointer-events-none absolute w-[300px] h-[300px] rounded-full bg-[#83588f] opacity-[0.25] blur-[110px]" />

      {/* Large centered logo */}
      <img
        src="/logo.png"
        alt="Korona Tours & Travel"
        data-testid="preloader-logo"
        className="preloader-logo relative w-44 sm:w-52 md:w-64 h-auto"
      />

      {/* Gold loading line */}
      <div className="relative mt-10 h-[2px] w-40 overflow-hidden rounded-full bg-white/10">
        <div className="preloader-line h-full w-full bg-gradient-to-r from-transparent via-[#c5a059] to-transparent" />
      </div>
    </div>
  );
}
